// Generales
import { mapActions, mapMutations, mapState } from "vuex";

// Mixinx
import IndexMixin from './index'

export default {

  mixins: [IndexMixin],

  async mounted() {
    this.resetNewSection();
    this.load(false);

    await this.getSection();
    await this.getCasDangers();
    await this.loadCountries();
  },

  computed: {

      ...mapState('sections', ['newSection', 'form']),
      ...mapState('nuevocas', { casDangers: 'tiposCas' })

  },

  methods: {

    ...mapMutations("dashboard", ["load"]),
    ...mapMutations("sections", ["setNewSection", "resetNewSection"]),

    ...mapActions("sections", ["getSectionById", "updateSection", "createSection"]),
    ...mapActions('nuevocas', { getCasDangers: 'listarTipoCas' }),
    ...mapActions("countries", ["loadCountries"]),

    async getSection() {
      if (!this.$route.params.id) return

      const dangers = await this.getSectionById({ id: this.$route.params.id });
      this.setNewSection({ 
        ...this.newSection,
        ...dangers,
        is_highlight: !!(dangers && dangers.is_highlight),
        section_rules: Array.isArray(dangers.section_rules)
          ? dangers.section_rules.map(rule => ({
              ...rule,
              is_cas: !!rule.is_cas,
              sys_list_id: rule.sys_list_id || null
            }))
          : [],
        dangers_id: (dangers && typeof dangers.prod_dangers === 'object') ? 
          dangers.prod_dangers.map(x => x.id) : []      
      });
    },

    async onHandleBtnOK() {
      try {
        this.$validator.validateAll(this.form.dataVvScope)
          .then(async (result) => {
            if (!result) return

            if (this.$refs.sectionForm && typeof this.$refs.sectionForm.validateRules === 'function') {
              const validRules = this.$refs.sectionForm.validateRules();
              if (!validRules) return;
            }

            const payload = { params: this.newSection, callback: this.onCallback }
            await this.form.action === 'CREATE' ? this.createSection(payload) : this.updateSection(payload);              
          });
      } catch (error) {
        // Error
      }
    },

    onCallback(status) {
      if (!status) return

      this.$router.push("/inventory/sections");
    }

  }

};
